const regex = {
    name: /^[a-zA-Z\s]{0,100}$/,
    name_length: /^.{0,100}$/,
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    email_length: /^.{0,254}$/,
    phoneUS: /^(\d{10})$|^(\d{3}-\d{3}-\d{4})$/,
    state:
      /^(AL|AK|AZ|AR|CA|CO|CT|DE|DC|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|PR|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY)$/i,
    zip: /^\d{5}$/,
    npi: /^\d{10}$/,
  };
  
  module.exports = {
    form_req_rep: {
      rules: [
        {
          name: "required",
          fields: ["firstName", "lastName", "email", "credential", "specialty", "facilitySearch", "address", "city", "state", "country", "zipCode", "npiNumber", "phoneNumber", "question", "agreed", "password", "confirmPassword", "age", "qICheckbox", "PTFormularyCheckbox", "clinicalEducatorCheckbox", "otherCheckbox", "otherText"],
          required: true,
          messages: {
            firstName: "Please enter first name.",
            lastName: "Please enter last name.",
            email: "Please enter your email address.", 
            credential: "Please select your credential.",
            specialty: "Please select your specialty.",
            facilitySearch: "Please enter your facility name.",
            address: "Please enter your address.",
            city: "Please enter your city.",
            state: "Please select your state/region.",
            country: "Please select a country.",
            zipCode: "Please enter your ZIP code.",
            phoneNumber: "Please enter your phone number.",
            npiNumber: "Please enter your NPI number.",
            question: "Please enter your message.",
            agreed: "You must agree to the terms",
            password: "Please enter your password.",
            confirmPassword: "Please enter your password.",
            age: "Please select your age of patients.",
            qICheckbox: "Please accept this checkbox.",
            PTFormularyCheckbox: "Please accept this checkbox.",
            medicalSciencesCheckbox: "Please accept this checkbox.",
            clinicalEducatorCheckbox: "Please accept this checkbox.",
            otherCheckbox: "Please accept this checkbox.",
            otherText: "Please enter your other text.",
          }
        },
        {
          name: "name format validation",
          fields: ["firstName", "middleName", "lastName"],
          validators: [regex.name],
          messages: {
            firstName: "Please enter valid first name. ",
            middleName: "Please enter valid middle name.",
            lastName: "Please enter valid last name."
          }
        },
        {
          name: "email format validation",
          fields: ["email"],
          validators: [regex.email],
          messages: {
            email: "Please enter valid email address."
          }
        },
        {
          name: "phone format validation",
          fields: ["phoneNumber"],
          validators: [regex.phoneUS],
          messages: {
            phoneNumber: "Please enter a valid phone number"
          }
        },
        {
          name: "state validation",
          fields: ["country"],
          validators: [regex.state],
          messages: {
            country: "Please select a valid state"
          }
        },
        {
          name: "zip format validation",
          fields: ["zipCode"],
          validators: [regex.zip],
          messages: {
            zipCode: "Please enter valid Zip code."
          }
        },
        {
          name: "npi format validation",
          fields: ["npiNumber"],
          validators: [regex.npi],
          messages: {
            npiNumber: "Please enter valid NPI number."
          }
        },
        {
          name: "consent valid",
          fields: ["agreed"],
          validators: [[true]],
          messages: {
            agreed: "You must agree to the terms"
          }
        },
      ],
    },
  };
  